import {BehaviorSubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {wwData$} from './worker-data';

export const depth$ = new BehaviorSubject({bids: [], asks: []});

wwData$.pipe(filter((o) => o.type === 'depth')).subscribe(({data}) => depth$.next(data));
